import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {DataService} from "../data.service";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {UtilService} from "../util.service";
import {ActivatedRoute, Router} from "@angular/router";

export enum ColumnType {
  Simple = 1,
  Image,
  List,
  Object,
  Boolean,
  Action
}

@Component({
    selector: 'app-general-list',
    templateUrl: './general-list.component.html',
    styleUrls: ['./general-list.component.scss'],
    standalone: false
})

export class GeneralListComponent implements OnInit {

  title = '';
  showNewBtn = false;
  newBtnTitle = 'New';

  items: any[] = [];
  dataSource = new MatTableDataSource(this.items);
  searchText = null;
  smallbar = false;

  columns: {id:string, label:string, type: ColumnType, sortDisabled?: boolean, colClass?:string, options?:any}[] = [];
  allColumns = [];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  service: DataService;
  activatedRoute: ActivatedRoute;
  router: Router;
  util: UtilService;
  constructor(
    private injector: Injector,
  ) {
    this.service = injector.get(DataService);
    this.activatedRoute = injector.get(ActivatedRoute);
    this.router = injector.get(Router);
    this.util = injector.get(UtilService);
  }

  ngOnInit(): void {
    this.loadFilterCache();
    this.fetchItems();
    this.setDatatable();
    this.allColumns = this.columns.map(item => item.id);
  }

  loadFilterCache() {
    if (this.title) {
      let key = 'measure_filter_'+this.title.toLowerCase().trim()
      const filter = localStorage.getItem(key);
      if (filter) {
        this.searchText = filter;
        this.applyFilter();
      }
    }
  }

  saveFilterCache() {
    let key = 'measure_filter_'+this.title.toLowerCase().trim()
    localStorage.setItem(key, this.searchText);
  }

  setDatatable() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = this.util.tableSorting;
  }

  handleFetchResponse(resp) {
    if (resp && resp.length) {
      this.items = resp;
      this.dataSource.data = this.items;
    }
  }

  applyFilter() {
    this.saveFilterCache();
    this.dataSource.filter = this.searchText.trim().toLowerCase();
  }

  fetchItems() {}

}
